import { ActionTypes } from "../constants";
import { getTreeFromNormalised, normaliseTree } from "../utilities/reducers";

const reduceLibrary = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_TMS_LIBRARY_SUCCESS:
            return action.data.reduce((prev, curr) => normaliseTree(prev, curr, 'subcategories', 'courses'), []);

        case ActionTypes.GET_TMS_CATEGORY_DETAILS_SUCCESS:
            return normaliseTree(state, action.data, 'subcategories');

        default:
            return state;
    }
};

export const getLibrary = (library) => (!library || !library.length) ? null : library.filter(({level}) => level === 0);
export const getCategory = (library, categoryId) => (!library || !library.length) ? null : getTreeFromNormalised(library, categoryId, 'subcategories');

export default reduceLibrary;
